import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { Aggregations, Filter } from '../filters';
import { FormGroup } from '@angular/forms';
import { EqualFilterComponent } from './equal/equal.component';
import { MatIconModule } from '@angular/material/icon';
import { RangeFilterComponent } from './range/range.component';
import { MultiSelectFilterComponent } from './multi-select/multi-select.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'cbre-filter',
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
  imports: [MatIconModule, EqualFilterComponent, MultiSelectFilterComponent, RangeFilterComponent],
})
export class FilterComponent {
  readonly filter = input<Filter>(null);
  readonly form = input<FormGroup<Record<string, any>>>(new FormGroup({}));
  readonly aggregations = input<Aggregations>({});
  readonly canRemoveFilter = input(false);
  readonly showLabel = input(true);

  readonly removeFilter = output<any>();
}
